import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { MatDialog } from '@angular/material/dialog';
import { ConsumerAmbassadorsProfile } from '../../../features/user-management/consumer-ambassadors/models/ConsumerAmbassadorsProfile';
import { UserStatusEnum, UserTabsEnum } from '../../../features/user-management/consumer-ambassadors/models/enum/UserStatusEnum';
import { ConsumerAmbassadorService } from '../../../features/user-management/consumer-ambassadors/services/consumer-ambassador.service';
import { CreateUserModelComponent } from '../create-user-model/create-user-model.component';
import Swal from 'sweetalert2';
import { MyprofileService } from '../../../features/user-management/consumer-ambassadors/services/connect/myprofile.service';
import { SubscriptionTypeEnum } from '../../../features/user-management/consumer-ambassadors/models/enum/SubscriptionTypeEnum';
import { SubscribtionStatusEnum } from '../../../features/user-management/consumer-ambassadors/models/enum/SubscribtionStatusEnum';
import { MemberSubscrpitionHistoryService } from '../../../features/user-management/consumer-ambassadors/services/connect/member-subscrpition-history.service';
import { AmbassadorPromotionLevelEnum } from '../../models/enums/AmbassadorPromotionLevelEnum';
import { MembershipInfo } from '../../../features/user-management/consumer-ambassadors/models/membershipInfo';
import { SystemModule } from '../../../features/central-hub/models/enums/SystemModule';

@Component({
  selector: 'app-consumer-ambassadors-profile',
  standalone: false,
  templateUrl: './consumer-ambassadors-profile.component.html'
})
export class ConsumerAmbassadorsProfileComponent {
  @Input() centralHubName: string;
  dataLoading = false
  openSideNav = false
  loading = false
  reNewSubscriptionLoading = false
  userInformation: ConsumerAmbassadorsProfile = new ConsumerAmbassadorsProfile()
  membershipInfo: MembershipInfo = new MembershipInfo
  subscriptions: Subscription[] = [];
  recordId: any = null
  userId: any = null
  userTabsEnum = UserTabsEnum
  subscriptionTypeEnum = SubscriptionTypeEnum
  subscribtionStatusEnum = SubscribtionStatusEnum
  ambassadorPromotionLevelEnum = AmbassadorPromotionLevelEnum
  userStatusEnum = UserStatusEnum
  isProfile= false
  systemModule = SystemModule
  constructor(
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private service: ConsumerAmbassadorService,
    private translate: TranslateService,
    private myprofileService: MyprofileService,
    private memberSubscrpitionHistoryService: MemberSubscrpitionHistoryService,
    private swalService: SwalService
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('id') && params.get('id') != 'profile') {
        this.recordId = params.get('id');
        if (this.router.url.includes('connect-user') && !this.recordId) {
          this.getUser();
        } else {
          this.getDetails();
        }
      } else {
        this.isProfile = true
        this.getUser();
      }
    })
    this.subscriptions.push(
      this.service.refreshList.subscribe((data: any) => {
        if (data) {
          this.getDetails();
        }
      })
    )
  }
  getUser() {
    this.dataLoading = true;
    this.myprofileService.GetUser(0).subscribe(
      (data: any) => {
        this.userInformation = data;
        this.dataLoading = false;
        // this.getUserProfile()
      },
      (error: any) => {

        this.dataLoading = false;
        console.log('Try again!, ' + error);
      });
  }
  getUserProfile() {
    this.dataLoading = true;
    this.myprofileService.getUserProfile().subscribe(
      (data: any) => {
        this.userId = data.id
        this.getMembershipInfo();
        this.userInformation.userId = data.id;
        this.userInformation.email = data.email;
        this.userInformation.username = data.userName;
        this.userInformation.name = data.name;
        this.userInformation.role = data.role;
        this.userInformation.permissions = data.permissions;
        this.userInformation.profilePicture = data.profilePicture;
        this.userInformation.userAvailability = data.userAvailability;
        this.dataLoading = false;

      },
      (error: any) => {

        this.dataLoading = false;
        console.log('Try again!, ' + error);
      });
  }

  getMembershipInfo() {
    this.dataLoading = true;
    let data: any = { userId: this.userId }
    this.dataLoading = true;
    this.myprofileService.getMembershipInfo(data).subscribe(
      (res: MembershipInfo) => {
        this.dataLoading = false;
        this.membershipInfo = res;
      }, (error: any) => {
        console.log('Faild');
      });
  }

  ngOnDestroy() {
    this.service.refreshList.next(false);
    this.service.closeDetails.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  getDetails() {
    this.dataLoading = true;
    this.service.getConsumerAmbassadorUserDetails(this.recordId).subscribe((data: any) => {
      this.dataLoading = false;
      this.userInformation = data;
    })
  }

  openUpdateForm() {
    const dialogRef = this.dialog.open(CreateUserModelComponent, {
      width: '560px',
      data: { record: this.userInformation }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getDetails();
      }
    });
  }

  deleteUser(id: any) {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes sure'), this.translate.instant('swalMsg.Areyousuretodelete'))
      .then((result) => {
        if (result.value) {
          this.dataLoading = true;
          this.service.deleteUser(id).subscribe(
            (data: any) => {
              this.dataLoading = false;
              Swal.fire({
                title: this.translate.instant('messages.userAccountDeleted'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok'),
              })
                .then(() => {
                  this.router.navigate([`/admin/${SystemModule.UserManagement}/ambassador-users`]);
                });
            },
            (err: any) => {
              this.dataLoading = false;
              // console.log('Try again!, ' + error);
              const errors = JSON.parse(err.detail);
              let message = '';
              if (err.detail) {
                errors.ErrorDTO.forEach((error: any) => {
                  // if (error.ErrorCode === 'CantDelete') {
                  //   message = error.Error;
                  // }
                });
              } else {
                message = err.title;
              }
              this.swalService.swalFailed(message);
            });
        }
      });
  }

  suspendUnSuspendUser(userId: any, status: any) {
    let title = '';
    let subTitle = '';
    let text = '';
    if (status == 'SUSPENDED') {
      title = this.translate.instant('swalMsg.areYousuretosuspendThisUser');
      subTitle = this.translate.instant('swalMsg.suspention message');
      text = this.translate.instant('messages.userAccountSuspended');
    } else {
      title = this.translate.instant('swalMsg.areYousuretounsuspendThisUser');
      text = this.translate.instant('messages.userAccountReactivated');
    }
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes sure'), title, subTitle)
      .then((result) => {
        if (result.value) {
          this.dataLoading = true;
          this.service.changeStatus(userId, status).subscribe(
            (data: any) => {
              this.dataLoading = false;
              Swal.fire({
                title: text,
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok'),
              })
                .then(() => {
                  this.service.refreshList.next(true);
                });
            },
            (err: any) => {
              this.dataLoading = false;
              // console.log('Try again!, ' + error);
              const errors = JSON.parse(err.detail);
              let message = '';
              if (err.detail) {
                errors.ErrorDTO.forEach((error: any) => {
                  // if (error.ErrorCode === 'CantDelete') {
                  //   message = error.Error;
                  // }
                });
              } else {
                message = err.title;
              }
              this.swalService.swalFailed(message);
            });
        }
      });
  }

  resendVerificationMail(id: any) {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes sure'), this.translate.instant('swalMsg.Areyousuretoresendverification'))
      .then((result) => {
        if (result.value) {
          this.dataLoading = true;
          this.service.resendVerification(id).subscribe(
            (data: any) => {
              this.dataLoading = false;
              Swal.fire({
                title: this.translate.instant('swalMsg.verificationEmailResentSuccessfully'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok'),
              })
                .then(() => {
                  this.service.refreshList.next(true);
                });
            },
            (err: any) => {
              this.dataLoading = false;
              // console.log('Try again!, ' + error);
              const errors = JSON.parse(err.detail);
              let message = '';
              if (err.detail) {
                errors.ErrorDTO.forEach((error: any) => {
                  // if (error.ErrorCode === 'CantDelete') {
                  //   message = error.Error;
                  // }
                });
              } else {
                message = err.title;
              }
              this.swalService.swalFailed(message);
            });
        }
      });
  }


  print() {
    window.print();
  }

  renewSubscription() {
    this.reNewSubscriptionLoading = true
    this.memberSubscrpitionHistoryService.reNewSubscription({ amount: 0 }).subscribe(
      (res: any) => {
        this.reNewSubscriptionLoading = false
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: '',
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        }).then((result) => {
          this.getUser();
        });
      }, (error: any) => {
        console.log('Faild');
        this.reNewSubscriptionLoading = false
      });

  }

  viewHistory() {
    this.openSideNav = true;


  }

  closeSidenav(e: any) {
    this.openSideNav = false;
  }
}
